import { Box } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import type { CoverageSchemaAnalysis, TargetSchema } from "@/types";
import { StyledTab, StyledTabs } from "@/components/ui/mui/StyledTabs";
import { SCHEMA_LABELS } from "../../utils/reviewUtils";

interface SchemaSelectorProps {
  schemaAnalyses: CoverageSchemaAnalysis[];
  selectedIndex: number;
  onChange: (index: number) => void;
  mappingValidationIssues?: Array<{ schema: TargetSchema; message: string }>;
}

/**
 * Tab selector for switching between multiple schema analyses
 */
export const SchemaSelector = ({
  schemaAnalyses,
  selectedIndex,
  onChange,
  mappingValidationIssues = [],
}: SchemaSelectorProps) => {
  // Build set of schemas that have errors
  const schemasWithErrors = new Set(mappingValidationIssues.map((issue) => issue.schema));

  return (
    <Box sx={{ mb: 3 }}>
      <StyledTabs value={selectedIndex} onChange={(_, newValue) => onChange(newValue)}>
        {schemaAnalyses.map((analysis) => {
          const hasError = schemasWithErrors.has(analysis.target_schema);

          return (
            <StyledTab
              key={analysis.target_schema}
              label={SCHEMA_LABELS[analysis.target_schema]}
              icon={hasError ? <ErrorIcon fontSize="small" color="error" /> : undefined}
              iconPosition="end"
            />
          );
        })}
      </StyledTabs>
    </Box>
  );
};
